<!-- this will display all the invoices associated with the item -->
<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <v-card-title>Item Transaction History</v-card-title>
      <v-card-text>
        <h2 class="text-uppercase primary--text">{{ item.item_name }}</h2>
        <div class="d-flex justify-end">
          <v-btn
            small
            color="primary"
            class="mb-2"
            @click="print_table"
            :loading="loading"
            >Print Table</v-btn
          >
        </div>
        <v-text-field
          v-model="search"
          label="Search"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          class="mb-2"
        ></v-text-field>

        <v-data-table
          :items="transactionHistory"
          :headers="headers"
          :loading="loading"
          :search="search"
        >
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submit" :loading="loading">Submit</v-btn>
        <v-btn @click="$emit('close')"> Close</v-btn>
        <v-spacer></v-spacer>
        <p class="caption grey--text">itemProfileModal.vue</p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  props: ["item"],
  data() {
    return {
      transactionHistory: [],
      search: "",
      dialog: true,
      loading: false,
      headers: [
        { text: "Invoice ID", value: "invoice.id" },
        { text: "Date", value: "invoice.invoice_date" },
        { text: "Customer Name", value: "invoice.customer.customer_name" },

        { text: "Quantity", value: "quantity" },
        { text: "Remarks", value: "invoice.purpose" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      default_server_url: "default_server_url",
    }),
  },
  methods: {
    print_table() {},
    async getTransactionHistory() {
      this.loading = true;

      try {
        let response = await axios.get(
          "get_item_transaction_history/" + this.item.id
        );
        this.transactionHistory = response.data;
        console.log("Transaction History:", this.transactionHistory);
        this.loading = false;
      } catch (error) {
        console.error("Error fetching transaction history:", error);
        this.loading = false;
      }
    },
    submit() {
      return;
    },
  },
  created() {
    this.getTransactionHistory();
  },
};
</script>

<style lang="scss" scoped></style>
